import styled from 'styled-components';
import { PADDING } from 'common/constants/sizes';
import { lightColorPalette } from '@linearb/linui-common';

export const StyledInputLabel = styled.header`
  margin-bottom: 0.7rem;
  font-size: 1.2rem;
  color: ${lightColorPalette.lbTextSubdued};
`;

export const StyledRadioLabel = styled(StyledInputLabel)`
  width: 19rem;
`;

export const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  font-size: 2rem;
  svg#Close {
    margin-left: auto;
    &:hover {
      opacity: 0.7;
    }
  }
`;

export const StyledFooter = styled.footer`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 1rem;
`;

export const StyledMonitoringRulesForm = styled.div`
  padding: ${PADDING.small};
  margin-top: 1rem;
  min-height: 30rem;
  padding-bottom: 3rem;
  position: relative;
`;

export const StyledOrgDetectionStrategy = styled.div`
  font-size: 1.2rem;
  margin-top: 2rem;
  & ${StyledInputLabel} {
    margin-top: 0.6rem;
    margin-left: none;
  }
`;

export const StyledOrgsCounter = styled(StyledInputLabel)`
  margin-left: 1rem;
`;
